'use client';

import { ReactNode, useEffect } from 'react';

import { useTenantConfigQuery } from '@northladder/apis';
import { useRegionStore } from '@northladder/services';

import { useRouteURL } from '~/features';

interface ITenantConfigProviderProps {
  children: ReactNode;
}

/**
 * -----------------------------------------------------------------------------
 * This provider fetches and provides the tenant configuration for the application
 * and injects it into the active region of the app.
 */
export function TenantConfigProvider({ children }: ITenantConfigProviderProps) {
  const { onUpdateTenantConfig } = useRegionStore();
  const { sessionId, assessmentType, platform } = useRouteURL();

  const { data: configData } = useTenantConfigQuery({ identifier: platform });

  useEffect(() => {
    if (configData?.apiBaseURL) {
      onUpdateTenantConfig(configData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configData?.apiBaseURL, assessmentType, sessionId]);

  return children;
}
